module.exports = __webpack_public_path__ + "static/media/select.5098c6c8.png";